
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetDeeplinkContentResponseDto } from "../dtos/get-deeplinking-content.response.dto";
import { GetDeeplinkContentDto } from "../dtos/get-deeplinking-content.dto";
import { UpdateDeeplinkingContentDto } from "../dtos/update-deeplinking-content.dto";
@Injectable()
export class DeeplinkService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    getDeeplinkingContent(getDeeplinkingContentDto:GetDeeplinkContentDto) : Promise<any>{
        return firstValueFrom(this.http.get<GetDeeplinkContentResponseDto>(`${URLS.DEEPLINKING_CONTENT_API}?courseCode=${getDeeplinkingContentDto.courseCode}&toolId=${getDeeplinkingContentDto.toolId}`,
            {
                headers: this.authService.getAuthHeaders()
            }
        ));

    }
    updateDeeplinkUpdatedDate(updateDeeplinkingContentDto:UpdateDeeplinkingContentDto) : Promise<any>{
        return firstValueFrom(this.http.put(`${URLS.DEEPLINKING_CONTENT_API}`,updateDeeplinkingContentDto,
            {
                headers: this.authService.getAuthHeaders()
            }
        ));

    }
}